import { observer } from 'mobx-react';
import * as React from 'react';
import { Route } from 'react-router';
import { CreateOrEditDisplayEventProfile } from './CreateOrEditDisplayEventProfile';
import { DisplayEventProfilesList } from './DisplayEventProfilesList';

@observer
export class DisplayEventProfilesView extends React.Component {
    public render() {
        return (
            <>
                <Route
                    path="/display-event-profiles/:displayEventProfileView"
                    exact
                    component={DisplayEventProfilesList}
                />
                <Route
                    path="/display-event-profiles/:displayEventProfileView/:displayEventProfileActions"
                    exact
                    component={CreateOrEditDisplayEventProfile}
                />
                <Route
                    path="/display-event-profiles/:displayEventProfileView/:guid/:displayEventProfileActions"
                    exact
                    component={CreateOrEditDisplayEventProfile}
                />
            </>
        );
    }
}
